<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const { fileType } = defineProps({
  fileType: {
    type: String,
    required: true,
  },
});

const fileTypeIcon = computed(() => {
  const fileIconMap = {
    '7z': 'i-aidexa-file-zip',
    csv: 'i-aidexa-file-csv',
    doc: 'i-aidexa-file-doc',
    docx: 'i-aidexa-file-doc',
    json: 'i-aidexa-file-txt',
    odt: 'i-aidexa-file-doc',
    pdf: 'i-aidexa-file-pdf',
    ppt: 'i-aidexa-file-ppt',
    pptx: 'i-aidexa-file-ppt',
    rar: 'i-aidexa-file-zip',
    rtf: 'i-aidexa-file-doc',
    tar: 'i-aidexa-file-zip',
    txt: 'i-aidexa-file-txt',
    xls: 'i-aidexa-file-xls',
    xlsx: 'i-aidexa-file-xls',
    zip: 'i-aidexa-file-zip',
  };

  return fileIconMap[fileType] || 'i-teenyicons-text-document-solid';
});
</script>

<template>
  <Icon :icon="fileTypeIcon" />
</template>
